import { useEffect } from 'react';

import { useLocation } from 'react-router-dom';
import { getPathWithoutLang } from 'shared/lib/converter';
import { isIndexablePath, langFromPathname, langHref, normalizeBasePath } from 'shared/lib/seo';

/**
 * @description
 * 언어별 self-referencing canonical 을 <head>에 주입합니다.
 * 필터 쿼리스트링(/listing?whereType=...)이나 비정규 도메인이 별도 문서로
 * 색인되는 것을 막고, hreflang 과 동일한 URL 규칙을 써서 집합 정합을 유지합니다.
 * (엣지 og-injector 는 JS 를 안 돌리는 크롤러에게 같은 canonical 을 주입 — 규칙 일치 필수)
 *
 * Hreflang 과 같은 이유로 react-helmet 대신 useEffect 로 <link> 를 직접 관리하며,
 * 색인 대상 공개 페이지에만 주입합니다 (noindex 페이지의 canonical 은 신호 충돌).
 */
function CanonicalLink() {
  const { pathname } = useLocation();

  useEffect(() => {
    const removeAll = () => {
      document.head.querySelectorAll('link[data-seo-canonical]').forEach((el) => el.remove());
    };
    removeAll();

    const basePath = normalizeBasePath(getPathWithoutLang(pathname));
    if (!isIndexablePath(basePath)) return undefined;

    const el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    el.setAttribute('href', langHref(langFromPathname(pathname), basePath));
    el.dataset.seoCanonical = 'true';
    document.head.appendChild(el);

    return removeAll;
  }, [pathname]);

  return null;
}

export default CanonicalLink;
